// IVA rules shared by Nota/Factura builders (HTML + dot-matrix TXT)
export const itemTaxRate = (it, settings) => {
  if (it?.tax_rate !== undefined && it?.tax_rate !== null) return Number(it.tax_rate) || 0;
  if (settings?.tax_enabled === false) return 0;
  return Number(settings?.default_tax_rate) || 0;
};
// true → IVA is inside the price (extract); false → IVA added on top (legacy Factura style)
export const ivaIncluded = (settings) => settings?.b2b_iva_add ? false : settings?.tax_included_in_price !== false;
